import type { Node, NodeProps } from "@xyflow/react";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle } from "./shared";
import type { WarehouseNodeData } from "./types";

type WarehouseFlowNode = Node<WarehouseNodeData, "warehouse">;

export function WarehouseNode({ data }: NodeProps<WarehouseFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <FlowNodeCard title="Warehouse">
        <p className="text-sm font-semibold">{data.name || "Unknown warehouse"}</p>
        <FlowNodeRow label="State" value={data.state || "-"} />
      </FlowNodeCard>
    </>
  );
}
